import { render } from "./destination_table_drawer.vue?vue&type=template&id=20630883&scoped=true"
import script from "./destination_table_drawer.vue?vue&type=script&lang=js"
export * from "./destination_table_drawer.vue?vue&type=script&lang=js"

import "./destination_table_drawer.vue?vue&type=style&index=0&id=20630883&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20630883"]])

export default __exports__